import React from "react";
import { useForm, useFieldArray } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";

const FormBurgerCheeses = ({
  selectedBurger,
  allCheeses,
  burgerCheeses,
  handleUpdateCheeses,
}) => {
  const cheesesMap = Object.fromEntries(
    burgerCheeses.map((c) => [c.cheese_id, true])
  );

  const defaultValues = {
    cheeses: allCheeses.map((cheese) => ({
      cheese_id: cheese.id,
      cheese_description: cheese.cheese_description,
      checked: !!cheesesMap[cheese.id],
    })),
  };

  const { register, handleSubmit, control } = useForm({
    defaultValues,
  });

  const { fields } = useFieldArray({
    control,
    name: "cheeses",
  });

  const onSubmit = (data) => {
    const cheeses = data.cheeses.map((c) => ({
      ...c,
      burger_type: selectedBurger.id,
    }));
    handleUpdateCheeses(cheeses);
  };

  return (
    <div className="container">
      <div className="burger-cheeses-container mx-auto">
        <h4 className="text-center fw-bold products-title mb-4">
          Hamburguesa {selectedBurger.type_description}
        </h4>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Queso</th>
                  <th scope="col">Incluir</th>
                </tr>
              </thead>
              <tbody>
                {fields.map((field, index) => (
                  <tr key={field.id}>
                    <td>
                      <input
                        type="hidden"
                        {...register(`cheeses.${index}.cheese_id`)}
                      />
                      <input
                        type="hidden"
                        {...register(`cheeses.${index}.cheese_description`)}
                      />
                      {field.cheese_description}
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        {...register(`cheeses.${index}.checked`)}
                        className="form-check-input"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-4">
            <button type="submit" className="btn btn-success me-3">
              Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormBurgerCheeses;